import { gql } from '@apollo/client'

export const GET_TENANT_POS_STORE_IDS = gql`
  query GetTenantPOSStoreIds {
    tenantPosStoreIds
  }
`
